export enum FileExtension {
  Pdf = 'pdf',
  Doc = 'doc',
  Docx = 'docx',
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Png = 'png',
  Xls = 'xls',
  Xlsx = 'xlsx',
  Csv = 'csv',
}
